import { useCallback, useContext } from 'react';
import {
    ActionHandler,
    useIntegratedActionBroadcaster,
} from '../../../action-broadcaster/use-integrated-action-broadcaster';
import { useAdditionalInfos } from '../../hooks/use-additional-infos/additional-infos-provider';
import { WorkspacePanelContext } from '../../../panels/workspace-panel-provider';

export function useTogglePinnedMessagesShortcut(isFirstResponder: boolean): void {
    const { togglePinnedSection } = useAdditionalInfos();
    const workspacePanelUuid = useContext(WorkspacePanelContext)?.uuid;

    const handleEventPanelAction: ActionHandler<'EVENT_V2'> = useCallback(
        (action) => {
            if (
                action.type === 'TOGGLE_PINNED_MESSAGES_SECTION' &&
                workspacePanelUuid !== undefined &&
                action.payload.workspacePanelClientUuid === workspacePanelUuid
            ) {
                togglePinnedSection();
                return true;
            }
        },
        [togglePinnedSection, workspacePanelUuid]
    );

    const handleFrRootAction: ActionHandler<'ROOT'> = useCallback(
        (action) => {
            if (action.type === 'TOGGLE_PINNED_MESSAGES_VIEW') {
                togglePinnedSection();
                return true;
            }
        },
        [togglePinnedSection]
    );

    useIntegratedActionBroadcaster({
        id: 'PINNED_MESSAGES_TOGGLE_EVENT_PANEL',
        windowType: 'EVENT_V2',
        handler: isFirstResponder ? undefined : handleEventPanelAction,
    });

    useIntegratedActionBroadcaster({
        id: 'PINNED_MESSAGES_TOGGLE_FR',
        windowType: 'ROOT',
        ignoreActiveWorkspaceWindowType: true,
        handler: isFirstResponder ? handleFrRootAction : undefined,
    });
}
